import { Flex, Modal, Text, Title } from '@wyz/ui';
import React from 'react';
import { Trans } from '~/common/context';

type Props = {
  dmsUnavailable: boolean;
  onClose: () => void;
};
function NoResultModal({ dmsUnavailable, onClose }: Props) {
  return (
    <Modal.Container open={true} onClose={onClose} centered>
      <Modal.Header variant='white' closeBtnClass='ms-auto' />
      <Modal.Body>
        <Flex
          direction='column'
          alignItems='center'
          className='text-center pb-4 space-y-2'
        >
          <NoResultImage className='mb-3' />
          <Title heading='lg' weight='bold' color='tertiary-bold' wrap>
            <Trans i18nKey='app.purchase.search_page.no_result_modal.title' />
          </Title>
          <Text id='search-no-result-modal' color='info'>
            {dmsUnavailable ? (
              <Trans i18nKey='app.purchase.search_page.no_result_modal.dms_unavailable' />
            ) : (
              <Trans i18nKey='app.purchase.search_page.no_result_modal.message' />
            )}
          </Text>
        </Flex>
      </Modal.Body>
    </Modal.Container>
  );
}

export default NoResultModal;

function NoResultImage(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='176'
      height='158'
      viewBox='190 98 212 190'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M217.945 217.511L219.513 199.911C219.52 199.842 219.468 199.78 219.399 199.774C219.33 199.768 219.269 199.819 219.262 199.889L217.694 217.488C217.688 217.558 217.739 217.619 217.809 217.626C217.878 217.631 217.939 217.58 217.945 217.511Z'
        fill='#D8D7D5'
      />
      <path
        d='M228.517 224.354L208.071 231.943C208.006 231.967 207.972 232.04 207.997 232.106C208.021 232.171 208.093 232.204 208.158 232.18L228.605 224.592C228.67 224.567 228.703 224.495 228.679 224.429C228.655 224.364 228.582 224.33 228.517 224.354Z'
        fill='#D8D7D5'
      />
      <path
        d='M237.335 233.518L239.966 220.175C239.979 220.106 239.935 220.04 239.867 220.026C239.799 220.012 239.732 220.057 239.719 220.125L237.088 233.469C237.075 233.537 237.119 233.604 237.187 233.618C237.255 233.631 237.321 233.587 237.335 233.518Z'
        fill='#D8D7D5'
      />
      <path
        d='M326.353 272.201H254.246L261.19 224.302H319.409L326.353 272.201Z'
        fill='#C4CED9'
      />
      <path
        d='M379.954 232.749H200.645C196.089 232.749 192.396 229.039 192.396 224.462V110.986C192.396 106.41 196.089 102.7 200.645 102.7H379.954C384.509 102.7 388.202 106.41 388.202 110.986V224.462C388.202 229.039 384.509 232.749 379.954 232.749Z'
        fill='#DAE0E7'
      />
      <path
        d='M374.989 219.038H205.184C200.628 219.038 196.935 215.328 196.935 210.752V114.835C196.935 110.259 200.628 106.549 205.184 106.549H374.989C379.545 106.549 383.238 110.259 383.238 114.835V210.752C383.238 215.328 379.545 219.038 374.989 219.038Z'
        fill='#C4CED9'
      />
      <path
        d='M341.636 275.69H238.962V270.708C238.962 266.855 242.071 263.732 245.906 263.732H334.693C338.528 263.732 341.636 266.855 341.636 270.708V275.69Z'
        fill='#DAE0E7'
      />
      <path
        d='M292.573 226.349C292.573 228.566 290.784 230.362 288.577 230.362C286.371 230.362 284.583 228.566 284.583 226.349C284.583 224.133 286.371 222.336 288.577 222.336C290.784 222.336 292.573 224.133 292.573 226.349Z'
        fill='#B8C4D1'
      />
      <path
        d='M311.086 128.5L292.999 146.586L274.914 128.501L264 139.414L282.085 157.501L264 175.586L274.914 186.5L292.999 168.415L311.086 186.5L322 175.587L303.914 157.501L322 139.414L311.086 128.5Z'
        fill='#A5B4C5'
      />
      <path
        d='M365.527 253.583C358.714 253.583 351.898 251.003 346.655 245.826C342.891 242.11 340.444 237.556 339.319 232.75H339.325C339.336 232.795 339.346 232.84 339.357 232.886L339.75 232.75H349.879L340.33 236.067C341.238 238.495 342.504 240.815 344.129 242.948L373.479 232.75H379.953C383.293 232.75 386.168 230.757 387.466 227.89L392.448 226.158C392.412 223.534 391.997 220.916 391.206 218.391L388.202 219.434V215.914L390.015 215.284C389.494 214.139 388.89 213.023 388.202 211.945V211.936C394.847 222.328 393.714 236.313 384.732 245.494C379.461 250.882 372.496 253.583 365.527 253.583Z'
        fill='#FAFEFF'
      />
      <path
        d='M344.13 242.947C342.505 240.814 341.239 238.494 340.331 236.067L349.88 232.749H373.48L344.13 242.947ZM387.466 227.889C387.939 226.845 388.202 225.685 388.202 224.463V219.434L391.206 218.39C391.997 220.915 392.413 223.534 392.449 226.158L387.466 227.889Z'
        fill='#FEFFFF'
      />
      <path
        d='M339.358 232.884C339.347 232.838 339.336 232.793 339.326 232.747H339.75L339.358 232.884ZM388.202 215.912V211.942C388.891 213.02 389.494 214.137 390.016 215.282L388.202 215.912Z'
        fill='#FEFFFF'
      />
      <ellipse
        opacity='0.6'
        cx='365.398'
        cy='226.801'
        rx='27.1747'
        ry='27.2985'
        fill='white'
      />
      <path
        d='M310.81 272.923C308.232 275.558 308.268 279.794 310.891 282.383C313.514 284.972 317.73 284.935 320.308 282.301L348.998 252.976C361.092 260.623 377.264 259.074 387.692 248.416C399.721 236.12 399.551 216.355 387.31 204.271C375.07 192.186 355.394 192.358 343.365 204.654C332.937 215.313 331.677 231.583 339.499 243.598L310.81 272.923ZM347.276 208.515C337.369 218.641 337.51 234.918 347.59 244.87C357.671 254.822 373.874 254.681 383.781 244.555C393.687 234.428 393.547 218.151 383.466 208.2C373.386 198.248 357.183 198.389 347.276 208.515Z'
        fillRule='evenodd'
        clipRule='evenodd'
        fill='#A5B4C5'
      />
    </svg>
  );
}
